// extracted by mini-css-extract-plugin
export default {"redactedLog":"redactedLog--bd4d145057cb8eb2c63e","text":"text--c2f489275298dab54d50","ulWrap":"ulWrap--c756ea41fcb39956098c","redactedLabel":"redactedLabel--cd416110be11deea0427"};